import { z } from 'zod';

const envSchema = z.object({
  VITE_APP_NAME: z.string().min(1),
  VITE_APP_VERSION: z.string().min(1),
  VITE_API_BASE_URL: z.string().min(1),
  VITE_ENABLE_MOCKS: z.enum(['true', 'false']).default('false'),
  VITE_STRIPE_PUBLISHABLE_KEY: z.string().min(1),
  VITE_STRIPE_PMC_ID: z.string().optional(),
  VITE_APPINSIGHTS_CONNECTION_STRING: z.string().optional(),
  VITE_TCAP_PORTAL_URL: z.string().url(),
  VITE_HELP_CENTER_URL: z.string().url(),
  // Branding — optional, falls back to Pingco defaults when omitted
  VITE_BRAND_COLOR: z.string().default('#0ea5e9'),
  VITE_LOGO_URL: z.string().default('/images/PingCo-Logo.png'),
  VITE_LOGO_URL_DARK: z.string().optional(),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  console.error('❌ Invalid environment variables:', parsed.error.flatten().fieldErrors);
  throw new Error('Invalid environment variables. Check .env.example for required keys.');
}

export const env = parsed.data;

export const isDev = import.meta.env.DEV;
export const isTest = import.meta.env.MODE === 'test';
export const isMockMode = import.meta.env.VITE_ENABLE_MOCKS === 'true';
